import React, { useContext, useEffect } from 'react'

import i18n from 'live/services/i18n'

import { ResourceTypeConfigurationRouteContext } from '../AssetTypeConfiguration/AssetTypeConfigurationWrapper'
import { hasAdminPermission } from '../utils/permissions'
import { AssetTypeList } from './components'
import { Container } from './styles'
import { defaultParamsForResourceType } from '../utils/constants'

export const AssetTypeConfiguration: React.FC = () => {
    const { params, setParams } = useContext(ResourceTypeConfigurationRouteContext)

    useEffect(() => {
        if (!params) setParams(defaultParamsForResourceType)
    }, [])

    if (hasAdminPermission) {
        return (
            <Container>
                <AssetTypeList />
            </Container>
        )
    } else {
        return (
            <Container>
                <div className="permissionAlert">
                    <h1>{i18n('YOU DO NOT HAVE PERMISSION TO ACCESS THE RESOURCE TYPE CONFIGURATION.')}</h1>
                </div>
            </Container>
        )
    }
}
